<template>
  <b-sidebar
      :fullheight="true"
      :right="true"
      scroll="keep"
      :overlay="true"
      type="is-light"
      class="thread-sidebar"
      @close="$store.dispatch('clearThread')"
      v-model="open">

    <div v-if="tweets.length" class="my-4 mx-4">
      <h3 class="subtitle is-5">
        Thread by
        <link-to-profile :screen-name="tweets[0].user.screen_name">@{{ tweets[0].user.screen_name }}</link-to-profile>
      </h3>
      <tweet
          v-for="(tweet, index) in tweets"
          :data="tweet"
          :clickable="false"
          :key="tweet.id + '-' + index"
          :show-tweet-actions="!fromDB"
          :show-line-up="index > 0"
          :show-line-down="index < tweets.length - 1"

      ></tweet>
    </div>
  </b-sidebar>
</template>

<script>
import tweets from "../../api/tweets";
import LinkToProfile from "../controls/LinkToProfile";
import Tweet from "../tweet/Tweet";
import twitterText from "twitter-text";

export default {
  name: "ThreadSidebar",
  components: {Tweet, LinkToProfile},
  data() {
    return {
      open: false,
      tweets: [],
      fromDB: false
    }
  },
  computed: {
    thread() {
      return this.$store.state.app.sidebarThread
    },

    threadData() {
      return this.$store.state.app.sidebarThreadData
    }
  },
  watch: {
    thread(val) {
      if (val !== null) {
        this.loadThread(val.id, val.screen_name)
      }
    },

    threadData(val) {
      if (val !== null) {
        this.loadThreadData(val)
      }
    }
  },
  methods: {
    loadThread(id, screen_name) {
      this.tweets = []
      tweets.thread(id, screen_name).then(response => {

        this.tweets = response.data

        // add the reply on to the end if we have it
        // Note to self: this is a reply to the thread we're loaded - hence why it goes on the end
        if (this.$store.state.app.sidebarThreadReply) {
          this.tweets.push(this.$store.state.app.sidebarThreadReply)
        }
        this.fromDB = false
        this.open = true
      })
    },
    loadThreadData(data) {
      // when setting thread data we assume this is from a scheduled
      // thread from the database.
      this.fromDB = true
      this.tweets = [...data.tweets]
      this.tweets.forEach(tweet => {
        // need to set the user for each tweet to current profile
        tweet.user = this.$store.state.auth.profile

        // parse the text through twitter's autolinker to get html
        tweet.html = twitterText.autoLink(tweet.text)

        // load the quote RT
        if (tweet.quote_tweet) {
          const qt_parts = tweet.quote_tweet.split('/')
          const qt_id = qt_parts.pop() || qt_parts.pop()
          // this is some kind of weird reactive issue because
          // i got it to show up on time....
          tweets.getTweet(qt_id).then(response => {
            this.$set(tweet, 'quoted_status', response.data)
          })
        }
      })

      // if there's a reply_to ID, need to get this from the database
      if (data.reply_to) {
        tweets.getTweet(data.reply_to).then(response => {
          this.tweets.unshift(response.data)
        })
      }

      this.open = true
    }
  }
}
</script>

<style>
.b-sidebar.thread-sidebar .sidebar-background {
    background: rgba(10, 10, 10, 0.2);
}
.b-sidebar.thread-sidebar .sidebar-content {
  width: 50%;
  max-width: 500px;
}
</style>
